<div class="bg-white newheader">
    <div class="container d-flex align-items-center justify-content-end">


        <!-- Uncomment below if you prefer to use an image logo -->
        <!-- <a href="index.html" class="logo me-auto me-lg-0"><img src="assets/img/logo.png" alt="" class="img-fluid"></a>-->

        <nav id="navbar" class="navbar order-last order-lg-0">
            <ul>
                <li [routerLinkActive]="'active' "><a routerLink="../profile-info" class="nav-link scrollto">INFO</a>
                </li>
                <li [routerLinkActive]="'active' "><a routerLink="../profile-skills"
                        class="nav-link scrollto active">Skill </a></li>

                <li [routerLinkActive]="'active' "><a routerLink="../profile-ranking2" class="nav-link scrollto">Ranking
                    </a></li>
                <li [routerLinkActive]="'active' "><a routerLink="../profile-matches" class="nav-link scrollto">Matches
                    </a></li>
                <li [routerLinkActive]="'active' "><a routerLink="../profile-opponents"
                        class="nav-link scrollto">Opponents </a></li>
                <!-- <li [routerLinkActive]="'active' " class=""><a routerLink="../profile-tournament"
                        class="nav-link scrollto ">My
                        Tournaments </a></li> -->
                <li class="dropdown"><a routerLink="../profile-tournament" class="nav-link scrollto "
                        [routerLinkActive]="'active' ">My Tournaments </a>
                    <ul>
                        <li><a routerLink="../profile-tournament" [routerLinkActive]="'active'">My Tournaments</a> </li>
                        <li><a routerLink="../my-achivements" [routerLinkActive]="'active'">My Achivements</a></li>
                    </ul>
                </li>

                <li [routerLinkActive]="'active' " class="hide-list-responsive"><a routerLink="../profile-request"
                        class="nav-link scrollto ">Partner
                        Request
                    </a>
                </li>
                <li [routerLinkActive]="'active' " class="hide-list-responsive"><a routerLink="../contest-history"
                        class="nav-link scrollto " (click)="onNavigateToMyContest()">Contest
                        History
                    </a>
                </li>
                <li class="menu-three-dout">
                    <a>
                        <i class='bx bx-dots-horizontal-rounded' (click)="menues.toggle($event)"></i>
                    </a>

                    <p-overlayPanel #menues>
                        <ng-template pTemplate="content">
                            <ul class="menue-three-dout-list">
                                <li [routerLinkActive]="'active' "><a routerLink="../profile-request"
                                        class="nav-link scrollto ">Partner
                                        Request
                                    </a>
                                </li>
                                <li [routerLinkActive]="'active' "><a routerLink="../contest-history"
                                        class="nav-link scrollto ">Contest
                                        History
                                    </a>
                                </li>
                            </ul>
                        </ng-template>
                    </p-overlayPanel>


                </li>
                <!-- <li><a href="membership.html" class="nav-link scrollto">Memberships </a></li> -->


            </ul>
            <i class="bi bi-list mobile-nav-toggle"></i>

        </nav><!-- .navbar -->

        <!-- <a href="#about" class="get-started-btn scrollto">Get Started</a> -->

    </div>



</div>